var errorPage = {};

errorPage.init = function() {
  window.addEventListener('popstate', function(event) {
    if (errorPage.isShow()) {
      errorPage.show();
    }
  });
  if (errorPage.isShow()) {
    errorPage.show();
  }
};

errorPage.isShow = function() {
  var segments = document.location.pathname.split('/');

  return segments[2] === 'error';
};

errorPage.show = function() {
  var errorMessage = `
    <p>Error: the application can't be initialized. Reload the page or try again later.</p>
    <button onclick="location.reload();" class="root-btn">Reload</button>`;

  document.body.innerHTML = `
    <header class="root-error-header">
        <img alt="Venue" class="root-error-logo" src="/ui/assets/images/logo_dfs_venue.png" />
        <hr />
    </header>
    <div class="root-error-content">
        ${errorMessage}
    </div>
    `;
};

export { errorPage };
